// src/admin/AdminCategories.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
const getCategoryImageUrl = (image) => {
  if (!image || typeof image !== 'string') return '';

  const cleanImage = image.trim();

  try {
    // URL complète
    if (/^https?:\/\//i.test(cleanImage)) {
      const url = new URL(cleanImage);

      // Image déjà servie par la bonne route
      if (url.pathname.includes('/api/product-images/')) {
        return url.href;
      }

      // Ancienne URL /images/ sur madadline.com
      if (
        ['madadline.com', 'www.madadline.com'].includes(url.hostname) &&
        url.pathname.includes('/images/')
      ) {
        const filename = url.pathname.split('/').pop();

        return filename
          ? `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`
          : '';
      }

      // URL externe
      return url.href;
    }

    // Chemin enregistré dans la base : images/nom-image.jpg
    const filename = cleanImage.split('/').filter(Boolean).pop();

    return filename
      ? `https://madadline.com/api/product-images/${encodeURIComponent(filename)}`
      : '';

  } catch (error) {
    console.error('Erreur URL image catégorie :', image, error);
    return '';
  }
};
function AdminCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [editing, setEditing]       = useState(null);
  const [saving, setSaving]         = useState(false);
  const [message, setMessage]       = useState(null);

  const [form, setForm] = useState({
    name: '',
    name_en: '',
    image: null,
    og_image: null,
    meta_title: '',
    meta_description: '',
  });

  const [previewImage, setPreviewImage] = useState('');
  const [previewOg, setPreviewOg]       = useState('');

  /* =========================================================
     CHARGEMENT
  ========================================================= */
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('https://madadline.com/api/categories');
      setCategories(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Erreur chargement catégories:', err);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  /* =========================================================
     HANDLERS
  ========================================================= */
  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleImage = (e) => {
    const { name, files } = e.target;
    if (!files?.[0]) return;

    const file = files[0];
    setForm(prev => ({ ...prev, [name]: file }));

    const reader = new FileReader();
    reader.onloadend = () => {
      if (name === 'image') {
        setPreviewImage(reader.result);
      } else if (name === 'og_image') {
        setPreviewOg(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  const resetForm = () => {
    setForm({
      name: '',
      name_en: '',
      image: null,
      og_image: null,
      meta_title: '',
      meta_description: '',
    });
    setPreviewImage('');
    setPreviewOg('');
    setEditing(null);
    setShowForm(false);
    setMessage(null);
  };

  const handleEdit = (cat) => {
    setForm({
      name: cat.name || '',
      name_en: cat.name_en || '',
      image: null,
      og_image: null,
      meta_title: cat.meta_title || '',
      meta_description: cat.meta_description || '',
    });
setPreviewImage(getCategoryImageUrl(cat.image));
setPreviewOg(getCategoryImageUrl(cat.og_image));    setEditing(cat.id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  /* =========================================================
     SOUMISSION
  ========================================================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!form.name.trim()) {
      setMessage({ type: 'error', text: 'Le nom est obligatoire.' });
      return;
    }

    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const fd = new FormData();

      fd.append('name', form.name.trim());
      fd.append('name_en', form.name_en.trim() || form.name.trim());

      if (form.meta_title) fd.append('meta_title', form.meta_title.trim());
      if (form.meta_description) fd.append('meta_description', form.meta_description.trim());
      if (form.image) fd.append('image', form.image);
      if (form.og_image) fd.append('og_image', form.og_image);

      if (editing) {
        fd.append('_method', 'PUT');
        await axios.post(`https://madadline.com/api/categories/${editing}`, fd, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        setMessage({ type: 'success', text: '✓ Catégorie modifiée' });
      } else {
        await axios.post('https://madadline.com/api/categories', fd, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        setMessage({ type: 'success', text: '✓ Catégorie créée' });
      }

      await fetchCategories();

      setTimeout(() => {
        resetForm();
      }, 1200);

    } catch (err) {
      console.error('Erreur enregistrement:', err);
      const errs = err.response?.data?.errors;
      const first = errs ? Object.values(errs)[0]?.[0] : null;

      setMessage({
        type: 'error',
        text: first || err.response?.data?.message || "Erreur lors de l'enregistrement.",
      });
    } finally {
      setSaving(false);
    }
  };

  /* =========================================================
     SUPPRESSION
  ========================================================= */
  const handleDelete = async (cat) => {
    if (cat.count > 0) {
      alert(`Impossible de supprimer "${cat.name}" : ${cat.count} produit(s) utilisent cette catégorie.`);
      return;
    }

    if (!window.confirm(`Supprimer la catégorie "${cat.name}" ?`)) return;

    try {
      const token = localStorage.getItem('auth_token');
      await axios.delete(`https://madadline.com/api/categories/${cat.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage({ type: 'success', text: '✓ Catégorie supprimée' });
      fetchCategories();
      setTimeout(() => setMessage(null), 2500);
    } catch (err) {
      console.error('Erreur suppression:', err);
      setMessage({
        type: 'error',
        text: err.response?.data?.message || 'Erreur lors de la suppression.',
      });
    }
  };

  /* =========================================================
     RENDER
  ========================================================= */
  return (
    <div className="admin-categories">

      <header className="admin-page-head">
        <div>
          <h1>Catégories</h1>
          <p>{categories.length} catégorie{categories.length > 1 ? 's' : ''}</p>
        </div>
        <button
          type="button"
          className="admin-btn admin-btn--primary"
          onClick={() => { resetForm(); setShowForm(true); }}
        >
          + Nouvelle catégorie
        </button>
      </header>

      {message && (
        <div className={`admin-alert admin-alert--${message.type === 'success' ? 'success' : 'error'}`}>
          {message.text}
        </div>
      )}

      {showForm && (
        <div className="admin-card">
          <div className="admin-card__head">
            <h2>{editing ? 'Modifier la catégorie' : 'Créer une catégorie'}</h2>
            <button
              type="button"
              className="admin-btn-sm admin-btn-sm--danger"
              onClick={resetForm}
            >
              ✕ Fermer
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="admin-form__grid">

              <div className="admin-form__group">
                <label>Nom (FR) *</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Ex: Robes longues"
                  required
                />
              </div>

              <div className="admin-form__group">
                <label>Nom (EN)</label>
                <input
                  type="text"
                  name="name_en"
                  value={form.name_en}
                  onChange={handleChange}
                  placeholder="Ex: Long dresses"
                />
              </div>

              {/* ⭐ Image de catégorie */}
              <div className="admin-form__group">
                <label>Image de la catégorie</label>
                <input
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={handleImage}
                />
                {previewImage && (
                  <div className="admin-form__preview">
                    <img src={previewImage} alt="Aperçu" />
                  </div>
                )}
              </div>

              {/* ⭐ SEO — Meta Title */}
              <div className="admin-form__group">
                <label>Meta Title (SEO)</label>
                <input
                  type="text"
                  name="meta_title"
                  value={form.meta_title}
                  onChange={handleChange}
                  placeholder="Titre pour le partage"
                  maxLength={60}
                />
              </div>

              {/* ⭐ SEO — Meta Description */}
              <div className="admin-form__group admin-form__group--full">
                <label>Meta Description (SEO)</label>
                <textarea
                  name="meta_description"
                  value={form.meta_description}
                  onChange={handleChange}
                  placeholder="Description affichée sur Google et les réseaux sociaux"
                  rows={2}
                  maxLength={160}
                />
              </div>

              {/* ⭐ SEO — Image OG */}
              <div className="admin-form__group">
                <label>Image de partage (Open Graph)</label>
                <input
                  type="file"
                  name="og_image"
                  accept="image/*"
                  onChange={handleImage}
                />
                {previewOg && (
                  <div className="admin-form__preview">
<img
  src={previewOg}
  alt="Aperçu OG"
  onError={(e) => {
    console.error('Image OG introuvable :', e.currentTarget.src);
  }}
/>                  </div>
                )}
              </div>
            </div>

            <div className="admin-form__actions">
              <button
                type="submit"
                className="admin-btn admin-btn--primary"
                disabled={saving}
              >
                {saving ? 'Enregistrement…' : editing ? 'Mettre à jour' : 'Créer la catégorie'}
              </button>
              <button
                type="button"
                className="admin-btn"
                onClick={resetForm}
              >
                Annuler
              </button>
            </div>
          </form>
        </div>
      )}

      {loading ? (
        <div className="admin-loading"><div className="spinner" /></div>
      ) : categories.length === 0 ? (
        <div className="admin-empty">
          <p>Aucune catégorie pour le moment.</p>
          <button
            type="button"
            className="admin-btn admin-btn--primary"
            onClick={() => setShowForm(true)}
          >
            Créer la première catégorie
          </button>
        </div>
      ) : (
        <div className="admin-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Image</th>
                <th>Nom (FR)</th>
                <th>Nom (EN)</th>
                <th>Slug</th>
                <th>Produits</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat, index) => (
                <tr key={cat.id ?? `cat-${index}`}>
                  <td>
                    {cat.image ? (
                      <img
  src={getCategoryImageUrl(cat.image)}
  alt={cat.name || 'Catégorie'}
  style={{
    width: 48,
    height: 48,
    objectFit: 'cover',
    borderRadius: 8,
    background: '#F8F6F0',
  }}
  loading="lazy"
  onError={(e) => {
    console.error(
      'Image catégorie introuvable :',
      e.currentTarget.src
    );
    e.currentTarget.style.display = 'none';
  }}
/>
                    ) : (
                      <div style={{
                        width: 48, height: 48, borderRadius: 8,
                        background: 'linear-gradient(135deg, #F8F6F0, #EAE6DA)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#C21E56', fontSize: 18, fontWeight: 700,
                      }}>
                        {(cat.name || '?').charAt(0).toUpperCase()}
                      </div>
                    )}
                  </td>
                  <td><strong>{cat.name || '—'}</strong></td>
                  <td>{cat.name_en || '—'}</td>
                  <td>
                    <code style={{ fontSize: 12, color: '#666' }}>
                      /{cat.slug || '—'}
                    </code>
                  </td>
                  <td>
                    <span className="admin-badge admin-badge--neutral">
                      {cat.count || 0} produit{cat.count > 1 ? 's' : ''}
                    </span>
                  </td>
                  <td>
                    <div className="admin-table__actions">
                      <button
                        type="button"
                        onClick={() => handleEdit(cat)}
                        className="admin-btn-sm admin-btn-sm--edit"
                      >
                        Modifier
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDelete(cat)}
                        className="admin-btn-sm admin-btn-sm--danger"
                      >
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminCategories;